/* raw layout hash: _default-web-layout:a4e231ba1c78fcf2fdab9ef0821c5be337cf0ac67021bd759dc46962f4bdc199 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Layout identity: _default-web-layout — the project's default page shell.
export default function DefaultWebLayout() {
  return <AppShell />;
}
